const getHeight = callback => {
  callback(0);
};

const StatusBarManager = {
  getHeight,
};

export default StatusBarManager;
